import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { entityPath, buildReturnTo } from './entityPaths';

/**
 * EntityLink — clickable chip that navigates to an entity detail view.
 *
 * Types: 'quote' | 'sales-order' | 'production-order' | 'task' | 'inventory-item' | 'invoice' | 'customer'
 *
 * Uses URL-based navigation so the target page auto-opens the entity
 * via the existing initialDetailTarget mechanism in App.js.
 *
 * returnLabel/returnType/returnId populate location.state.returnTo so the target
 * page's BackButton shows "← {returnLabel}" and goes back to that entity.
 * returnPath (instead of returnType/returnId) sends it back to a URL, e.g. the dashboard.
 */

const EntityLink = ({ type, id, label, returnLabel, returnType, returnId, returnPath, style }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  if (!id || !label) return null;

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const path = entityPath(type, id);
    if (path) {
      const returnTo = buildReturnTo({ type, id, returnLabel, returnType, returnId, returnPath });
      navigate(path, { state: returnTo ? { returnTo } : undefined });
    }
  };

  return (
    <button
      className="entity-link"
      onClick={handleClick}
      title={t('entityLink.open', { type: t(`entityLink.types.${type}`, { defaultValue: type }), label })}
      style={style}
    >
      {label} →
    </button>
  );
};

export default EntityLink;
